

















import Select from "@/components/custom/select/Select.vue";
import { debounceProcess } from "@/helpers/debounce";
import { useContactData } from "@/hooks/contact";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { DEFAULT_PAGE, ONE } from "@/models/constant/global.constant";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { LabelInValue } from "@/types";
import { ListContactDataDto } from "@interface/contact-data";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    Select,
  },
})
export default class SelectMechanic extends Vue {
  @Prop({ required: false, default: undefined })
  value!: LabelInValue | string;

  @Prop({ required: false, type: String })
  placeholder!: string;

  @Prop({ required: false, type: Boolean })
  labelInValue!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  options: Option<ListContactDataDto>[] = [];
  loading = false;

  pagination = {
    page: DEFAULT_PAGE,
    search: "",
  };

  allLoaded = false;

  created(): void {
    this.onSearch = debounceProcess(this.onSearch);

    this.fetchOptions({ sorts: "firstName:asc" });
  }

  fetchOptions(params?: RequestQueryParamsModel): void {
    const { findAllMechanic, toOptions } = useContactData();
    this.loading = true;
    findAllMechanic(params)
      .then(res => {
        this.allLoaded = res.currentPage + ONE === res.totalPages;
        const copy = [...this.options];
        this.options = [...copy, ...toOptions(res.data)];
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onChange(e?: LabelInValue | string): void {
    if (!e) {
      const params = new RequestQueryParams();
      params.sorts = "firstName:asc";
      this.resetState();
      this.fetchOptions(params);
    }
    this.$emit("input", e);
    this.$emit("change", e);
    this.$emit("update:meta", this.findOption(e));
  }

  onSearch(val = ""): void {
    const { filterBy } = useContactData();
    this.resetState();
    this.pagination.search = filterBy({
      firstName: val,
      lastName: val,
    });

    this.fetchOptions(this.buildParams());
  }

  findOption(
    value: string | { key: string; label: string } | undefined
  ): Option<ListContactDataDto> | undefined {
    if (typeof value === "string") {
      return this.options.find(e => value === e.value);
    } else {
      return this.options.find(e => e.value === value?.key);
    }
  }

  buildParams(): RequestQueryParamsModel {
    const params = new RequestQueryParams();
    const { page, search } = this.pagination;
    params.page = page - ONE;
    params.search = search;
    params.sorts = "firstName:asc";

    return params;
  }

  resetState(): void {
    this.pagination.page = ONE;
    this.options = [];
    this.allLoaded = false;
  }

  onScrollEnd(): void {
    if (this.allLoaded || this.loading) return;
    this.pagination.page += ONE;
    this.fetchOptions(this.buildParams());
  }
}
